import React from "react";
import { useSelector } from "react-redux";

const TakeTrainerCall = () => {
  const state = useSelector((state) => state.gcReducer);

  return <div></div>
};
            
export default TakeTrainerCall; 
